import React, { useState } from "react";
import { contactUs } from "../../src/GameServices/GameServices";
import swal from "sweetalert";

const useContact = () => {
  const [inputfields, setInputFields] = useState({
    name: "",
    email: "",
    message: "",
  });

  const sendNow = async (e) => {
    e.preventDefault();
    const data = {
      name: inputfields.name,
      email: inputfields.email,
      message: inputfields.message,
      userId: localStorage.getItem("user_id"),
      origin: "Contact Us",
    };

    const resp = await contactUs(data);
    // console.log(resp, "respresprespresp");
    if (resp.data) {
      setInputFields({
        name: "",
        email: "",
        message: "",
      });
      swal("Success!", "Response Submitted Successfully!", "success");
    } else {
      swal("error!", resp.response.data.message, "error");
    }
  };

  return {
    sendNow,
    inputfields,
    setInputFields,
  };
};

export default useContact;
